import GalerieImageOrder from "../components/GalerieImageOrder";
import GalerieCategoryName from "../components/GalerieCategoryName";
import React, { useEffect, useState } from "react";
import HeaderHomeAdmin from "../headers/headerHomeAdmin";
import * as API from "../services/API";
import Icon from "../util/Icon";
import { Modal, Button } from "react-bootstrap";
import {
	FaToggleOn,
	FaToggleOff,
} from "react-icons/fa";
import { useHistory } from "react-router-dom";
import Footer from "../components/Footer";
import ErrorModal from "../components/ErrorModal";
import ConfirmModal from "../components/ConfirmModal";
import SuccessToast from "../components/SuccessToast";

const MyModal = ({ onClose, onAdd, categories }) => {
	const [name, setName] = useState("");
	const [image, setImage] = useState(null);
	const [description, setDescription] = useState("");
	const [extension, setExtension] = useState("");
	const [categoryId, setCategoryId] = useState("");

	return (
	<Modal show={true} onHide={onClose} size="lg" backdrop="static" keyboard={false}>
		<Modal.Header closeButton>
			<Modal.Title>Importer une image</Modal.Title>
		</Modal.Header>

		<Modal.Body>

			<label>Nom</label>
			<input
				type="text"
				className="form-control m-2"
				onChange={(e)=>setName(e.target.value)}
			/>

			<label>Catégorie</label>
			<select
				className="form-control m-2"
				value={categoryId}
				onChange={(e) => setCategoryId(e.target.value)}
			>
				<option value="">-- Sans catégorie --</option>
				{categories.map(cat => (
					<option key={cat._id} value={cat._id}>
						{cat.name}
					</option>
				))}
			</select>

			<div className="mb-3">
				<label className="form-label">Choisissez une image :</label>
				<input 
					className="form-control"
					type="file"
					onChange={(e)=>{
						const file = e.target.files[0];
						if (!file) return;

						setExtension(file.type.replace("image/",""));

						const reader = new FileReader();
						reader.onloadend = () => setImage(reader.result);
						reader.readAsDataURL(file);
					}}
				/>
			</div>

			<label>Description</label>
			<textarea 
				className="form-control m-2"
				rows="5"
				maxLength="1200"
				value={description}
				onChange={(e)=>setDescription(e.target.value)}
			/>

		</Modal.Body>

		<Modal.Footer>
			<Button variant="secondary" onClick={onClose}>
				Annuler
			</Button>

			<Button
				variant="primary"
				disabled={!image || !name || !description}
				onClick={()=>{
					onAdd({
						name,
						image,
						description,
						extension,
						categoryId: categoryId || null
					})
				}}
			>
				Ajouter
			</Button>
		</Modal.Footer>
	</Modal>
	);
};

const ManageCategoriesModal = ({ onClose, categories, onAdd, onDelete, onMoveUp, onMoveDown, onRenamed}) => {
	const [name, setName] = useState("");
	const [selectedId, setSelectedId] = useState("");
	const sortedCategories = [...(categories || [])].sort(
		(a, b) => (a.order || 0) - (b.order || 0)
	);
	return (
		<Modal show={true} onHide={onClose} size="lg" backdrop="static" keyboard={false}>
			<Modal.Header closeButton>
				<Modal.Title>Gérer les catégories</Modal.Title>
			</Modal.Header>

			<Modal.Body>

				{/* LISTE */}
				<h5>Catégories</h5>

<div className="list-group mb-4">
	{sortedCategories.map((cat, index) => (
		<div
			key={cat._id}
			className="list-group-item d-flex justify-content-between align-items-center"
		>
			<div>
				<GalerieCategoryName category={cat} onRenamed={onRenamed} />
				<span className="text-muted ms-2">
					#{cat.order}
				</span>
			</div>

			<div>
				<Button
					size="sm"
					variant="secondary"
					className="me-2"
					disabled={index === 0}
					onClick={() => onMoveUp(cat)}
				>
					↑
				</Button>

				<Button
					size="sm"
					variant="secondary"
					className="me-2"
					disabled={index === sortedCategories.length - 1}
					onClick={() => onMoveDown(cat)}
				>
					↓
				</Button>

				<Button
					size="sm"
					variant="danger"
					onClick={() => {
						if (window.confirm("Supprimer cette catégorie ?")) {
							onDelete(cat._id);
						}
					}}
				>
					Supprimer
				</Button>
			</div>
		</div>
	))}
</div>

				<hr />

				{/* AJOUT */}
				<h5>Ajouter une catégorie</h5>

				<input
					type="text"
					className="form-control mt-2"
					placeholder="Nom de la catégorie"
					value={name}
					onChange={(e) => setName(e.target.value)}
				/>

			</Modal.Body>

			<Modal.Footer>
				<Button variant="secondary" onClick={onClose}>
					Fermer
				</Button>

				<Button
					variant="primary"
					disabled={!name.trim()}
					onClick={() => {
						onAdd({ name });
						setName("");
					}}
				>
					Ajouter
				</Button>
			</Modal.Footer>
		</Modal>
	);
};



function GalerieAdmin(){
	const [modalOpen, setModalOpen] = useState(null);
	const [GalerieListMembers, setGalerieListMembers] = useState([]);
	const [GalerieCategoriesList, setGalerieCategoriesList] = useState([]);
	const [error, setError] = useState(null);
	const [confirm, setConfirm] = useState(null);
	const [success, setSuccess] = useState(null);
    const history = useHistory();
	const openAddModal = () => setModalOpen("add");
	const openAddCategoryModal = () => setModalOpen("categories");
	const closeModal = () => setModalOpen(null);

	

	useEffect(() => {
		API.getMembersGalerieRequest(
			(res)=> setGalerieListMembers(res.data.data),
			()=>{}
		);

		API.getGalerieCategoriesAdminRequest(
			(res)=> {setGalerieCategoriesList(res.data)
			},
			()=>{}
		);
	}, []);

	const imagesByCategory = React.useMemo(() => {
		const map = {};

		[...GalerieCategoriesList]
			.sort((a, b) => (a.order || 0) - (b.order || 0))
			.forEach(cat => {
			map[cat._id] = {
				categoryId: cat._id,
                    name: cat.name,
				images: []
			};
		});

		map["uncategorized"] = {
			categoryId: "uncategorized",
                name: "Sans catégorie",
			images: []
		};

		GalerieListMembers.forEach(img => {
			const catId = img.categoryId;

			if (catId && map[catId]) {
				map[catId].images.push(img);
			} else {
				map["uncategorized"].images.push(img);
			}
		});

		return Object.values(map).filter(g => g.images.length > 0);

	}, [GalerieListMembers, GalerieCategoriesList]);

	const addGalerieCategories = (data) => {
		API.createGalerieCategoryRequest(
			data,
			()=>{
				API.getGalerieCategoriesAdminRequest(
					(res)=>{
						setGalerieCategoriesList(res.data);
						setSuccess("Categorie ajoutee avec succes.");
					},
					()=>{}
				);
			},
			(data)=>{setError(data);}
		);
	};
	const moveCategoryUp = (category) => {
	const sorted = [...GalerieCategoriesList].sort(
		(a, b) => (a.order || 0) - (b.order || 0)
	);

	const index = sorted.findIndex(c => c._id === category._id);

	if (index <= 0) return;

	const previous = sorted[index - 1];

	API.swapGalerieCategoriesOrderRequest(
		{
			firstId: category._id,
			secondId: previous._id
		},
		() => {
			API.getGalerieCategoriesAdminRequest(
				(res) => setGalerieCategoriesList([...res.data]),
				() => {}
			);
		},
		() => {}
	);
};

const moveCategoryDown = (category) => {
	const sorted = [...GalerieCategoriesList].sort(
		(a, b) => (a.order || 0) - (b.order || 0)
	);

	const index = sorted.findIndex(c => c._id === category._id);

	if (index === sorted.length - 1) return;

	const next = sorted[index + 1];

	API.swapGalerieCategoriesOrderRequest(
		{
			firstId: category._id,
			secondId: next._id
		},
		() => {
			API.getGalerieCategoriesAdminRequest(
				(res) => setGalerieCategoriesList([...res.data]),
				() => {}
			);
		},
		() => {}
	);
};
	const deleteGalerieCategory = (id) => {
		API.deleteGalerieCategoryRequest(
			{ _id: id },
			() => {
				API.getGalerieCategoriesAdminRequest(
					(response) => {setGalerieCategoriesList(response.data);},
					() => {}
				);
			},
			() => {}
		);
	};


	const addMemberGalerie = (data) => {API.createMemberGalerieRequest(data,()=>{API.getMembersGalerieRequest((response)=>{setGalerieListMembers(response.data.data);setSuccess("Image ajoutee avec succes.");closeModal();},(data)=>{})},(data)=>{setError(data);})};
	const deleteImageMember = (data) => {API.deleteMemberImageRequest({_id:data},()=>{setModalOpen(null);API.getMembersGalerieRequest((response)=>{setGalerieListMembers(response.data.data);},(data)=>{})},(data)=>{})};
	// const openAddModal = () => setModalOpen(<MyModal onClose={closeModal} onAdd={addMemberGalerie} categories={GalerieCategoriesList}/>);

	
	return (
		<>
            <div className="bg-light">
			    <HeaderHomeAdmin />
				<button
                    type="button"
                    className="btn btn-outline-secondary m-2"
                    onClick={() => history.goBack()}
                    >
                    ← Retour
                </button>
				<h1 className="text-center m-5 text-dark">Galerie des Membres :</h1>
				<button className="m-5 btn btn-dark border" onClick={openAddModal}>Ajouter une image</button>
				<button className="m-5 btn btn-dark border" onClick={openAddCategoryModal}>⚙️ Gérer les catégories</button>

				<div className="container">
				{imagesByCategory.map(group => (
					<div key={group.name} className="mb-5">

						<h2
							className="mb-4 pb-2"
							style={{
								borderBottom: "2px solid #ddd",
								fontWeight: 600
							}}
						>
							{group.name}
							<span className="text-muted ms-2" style={{fontSize:"0.8em"}}>
								({group.images.length})
							</span>
                            <GalerieImageOrder group={group} isPublic={false}
                              onSaved={(ids) => setGalerieListMembers(previous => {
                                const positions = new Map(ids.map((id, index) => [id, index]));
                                return previous.map(image => positions.has(image._id)
                                  ? { ...image, order: positions.get(image._id) } : image)
                                  .sort((a, b) => (a.order ?? Number.MAX_SAFE_INTEGER) - (b.order ?? Number.MAX_SAFE_INTEGER)
                                    || a._id.localeCompare(b._id));
                              })} />
						</h2>

						<div className="row">
							{group.images.map(image => (
								<div key={image._id} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">

									<div style={{position:"relative"}}>

										<Button
											className="btn btn-danger btn-sm"
											onClick={() =>
												setConfirm({
												title: "Supprimer l'image ?",
												message: "Cette action est irréversible. Continuer ?",
												onConfirm: () => deleteImageMember(image._id),
												})
											}
											style={{
												position:"absolute",
												top:8,
												right:8,
												zIndex:2
											}}
										>
											✕
										</Button>
										<img
											src={image.image}
											alt=""
											className="img-fluid rounded shadow"
											style={{
												objectFit:"cover",
												height:"200px",
												width:"100%"
											}}
										/>

									</div>

								</div>
							))}
						</div>

					</div>
				))}

				</div>
				<ConfirmModal
					show={!!confirm}
					title={confirm?.title}
					message={confirm?.message}
					onConfirm={confirm?.onConfirm}
					onClose={() => setConfirm(null)}
				/>
				<ErrorModal
				show={!!error}
				message={error}
				onClose={() => setError(null)}
				/>
				<SuccessToast
					show={!!success}
					message={success}
					onClose={() => setSuccess(null)}
				/>
				{modalOpen === "add" && (
					<MyModal
						onClose={closeModal}
						onAdd={addMemberGalerie}
						categories={GalerieCategoriesList}
					/>
				)}

				{modalOpen === "categories" && (
					<ManageCategoriesModal
						onClose={closeModal}
						onAdd={addGalerieCategories}
						onDelete={deleteGalerieCategory}
						categories={GalerieCategoriesList}
						onMoveUp={moveCategoryUp}
						onMoveDown={moveCategoryDown}
                        onRenamed={(updated) => {
                            setGalerieCategoriesList((previous) => previous.map((category) =>
                                category._id === updated._id ? updated : category
                            ));
                            setSuccess("Catégorie renommée avec succès.");
                        }}
					/>
				)}
				
            </div>
            <Footer/>
		</>
	);
}


export default GalerieAdmin;
